



























































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
import GoldbeanExchange from './components/GoldbeanExchange.vue'
import GoldenbeanHarvest from './components/GoldenbeanHarvest.vue'
import LiveIncome from './components/LiveIncome.vue'
import GoldBeanListDeduction from './components/GoldBeanListDeduction.vue'

@Component({
  name: 'inventory',
  components: {
    GoldbeanExchange,
    GoldenbeanHarvest,
    LiveIncome,
    GoldBeanListDeduction
  }
})
export default class Inventory extends Vue {
  active = 1
  showLive = true
  async created() {
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  // 返回
  handelBack() {
    this.$router.back()
  }
}
